import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stat-card" }
const _hoisted_2 = { class: "stat-content box" }
const _hoisted_3 = { class: "stat-icon" }
const _hoisted_4 = { class: "stat-details" }
const _hoisted_5 = { class: "stat-huge" }
const _hoisted_6 = { class: "stat" }

import { toRefs } from 'vue'

  interface Props {
    icon: string
    text: string
    value: string | number
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    icon: null,
    text: null,
    value: null
  },
  setup(__props: any) {

const props = __props as {
    icon: string
    text: string
    value: string | number
  }

  
  const { icon, text, value } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(["fa", `fa-${_unref(icon)}`])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(value)), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(text)), 1)
      ])
    ])
  ]))
}
}

})